export default __webpack_public_path__ + "static/media/odvz_color.467be40a.png";